import { render, staticRenderFns } from "./WhatsAppPaidPromoModal.vue?vue&type=template&id=5cda9c55&scoped=true&"
import script from "./WhatsAppPaidPromoModal.vue?vue&type=script&lang=js&"
export * from "./WhatsAppPaidPromoModal.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppPaidPromoModal.vue?vue&type=style&index=0&id=5cda9c55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cda9c55",
  null
  
)

export default component.exports